<template>
  <div class="benefits" v-if="benefitItems">
    <div
      v-for="(benefitItem, index) in benefitItems"
      :key="index"
      class="benefits__item animation-item animation-item animation-top"
      :class="`animation-item--delay${index}`"
    >
      <div class="benefits__inner">
        <div class="benefits__icon" >
          <div class="benefits__icon-image">
            <img :class="benefitItem.icon"
               :src="require(`@/assets/icons/${benefitItem.icon}.svg`)"
              :alt="benefitItem.header"
            />
          </div>
        </div>
        <h3>{{benefitItem.header}}</h3>
        <p>{{benefitItem.text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'benefits',
  data: () => ({
    benefitItems: [
      {
        icon: 'icon-stats',
        header: 'STATYSTYKI',
        text: 'Podgląd zasobów materialno – cyfrowych',
      },
      {
        icon: 'icon-innovation',
        header: 'INNOWACJA',
        text: 'Innowacja procesowo – produktowa danych oraz ciał stałych',
      },
      {
        icon: 'icon-cloud',
        header: 'CHMURA',
        text: 'Bezpieczne przechowywanie danych',
      },
      {
        icon: 'icon-clients',
        header: 'KLIENCI',
        text: 'Dla wszystkich użytkowników',
      },
      {
        icon: 'icon-access',
        header: 'DOSTĘP',
        text: 'Dostęp online',
      },
      {
        icon: 'icon-docs',
        header: 'DOMUKENTY',
        text: 'Dokumety w postaci  cyfrowej',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
  .benefits {
    @media (min-width: 500px) {
      display: flex;
      flex-wrap: wrap;
    }
    &__item {
      text-align: center;
      margin-bottom: 20px;
      @media (min-width: 500px) {
        flex: 1 1 50%;
        max-width: 50%;
      }
      @media (min-width: 550px) {
        margin-bottom: 50px;
      }
      @media (min-width: 820px) {
        flex: 1 1 33.33333%;
        max-width: 33.33333%;
      }
    }
    &__inner {
      max-width: 215px;
      margin: 0 auto;
    }
    &__icon {
      height: 83px;
      display: flex;
      justify-content: center;
      align-items: end;
      img {
        width: 70px;
        height: auto;
        margin: 0 auto;
        display: block;
        &.icon-docs {
          width: 50px;
        }
      }
    }
    h3 {
      font-size: 16px;
      padding: 15px 0;
    }
    p {
      color: #383838;
      font-size: 14px;
      font-weight: 300;
    }
  }
</style>
